import CityPageTemplate from "../city-template/CityPageTemplate";
import { milfordNhConfig } from "./data";

export default function MilfordNHPage() {
  return <CityPageTemplate config={milfordNhConfig} />;
}